import { jsx as _jsx } from "react/jsx-runtime";
import UIIcon from 'UIComponents/icon/UIIcon'; // This component should be deprecated and teams should just use `UILockBadge` from Canvas directly
// https://tools.hubteamqa.com/ui-library/show/UIComponents/badge/UILockBadge

const UILock = props => {
  return /*#__PURE__*/_jsx(UIIcon, Object.assign({
    name: "locked"
  }, props));
};

export default UILock;